import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {getCurrentInstance, onMounted, ref} from 'vue';
import StringHelper from "~/ts/library/StringHelper";



const __default__ = {
    name: "ReviewWrapper"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let borderColor = ref<string>();
let instance = getCurrentInstance().proxy;

onMounted(() => {
    let color = window.getComputedStyle(instance.$el).color;
    let rgb = StringHelper.parseRGB(color);
    borderColor.value = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, .15) !important`;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "lh-primary review",
    style: _normalizeStyle({
            borderColor: _unref(borderColor)
        })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})